import { getFaces, linkFaces } from '@vlabs/api/luna-api/client';

import type { FaceId } from '@vlabs/api/luna-api/model';

export async function detachAllFacesFromList(id: string): Promise<void> {
  const pageSize = 1000;

  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const facesResponse = await getFaces({
      list_id: id,
      targets: ['face_id'],
      page_size: pageSize,
    });

    const faceIds = facesResponse.faces?.map(({ face_id }) => face_id) ?? [];

    if (!faceIds.length) {
      break;
    }

    // eslint-disable-next-line no-await-in-loop
    await linkFaces(id, {
      action: 'detach',
      face_ids: faceIds as FaceId[],
    });
    if (faceIds.length < pageSize) {
      break;
    }
  }
}
